import { resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/search.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "m-1 h-4"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_connect_wallet = _resolveComponent("connect-wallet")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center", { 'flex-col': _ctx.vertical, 'flex-row': !_ctx.vertical }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center rounded-md opacity-70 cursor-text hover:underline hover:opacity-90 hover:bg-white hover:bg-opacity-5", { 'dropdown-search': _ctx.vertical, 'hide-placeholder': !_ctx.vertical }])
    }, [
      _createVNode(_component_n_input, {
        type: "string",
        value: _ctx.transaction,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transaction) = $event)),
        placeholder: "Enter transaction",
        size: !_ctx.vertical ? 'small' : undefined,
        class: _normalizeClass(["blank-input p-1 w-full", { 'max-w-[300px] min-w-[75px]': !_ctx.vertical }]),
        onKeyup: _withKeys(_ctx.toTx, ["enter"])
      }, null, 8, ["value", "size", "class", "onKeyup"]),
      _hoisted_1
    ], 2),
    (_ctx.$route.name !== 'Home')
      ? (_openBlock(), _createBlock(_component_nomad_button, {
          key: 0,
          class: _normalizeClass(["uppercase pl-4", {
        'w-full mb-2 uppercase rounded-md hover:bg-white hover:bg-opacity-5':
          _ctx.vertical,
      }]),
          onClick: _ctx.toHome
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Home ")
          ]),
          _: 1
        }, 8, ["class", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.allowed)
      ? (_openBlock(), _createBlock(_component_connect_wallet, {
          key: 1,
          text: "Bridge",
          class: _normalizeClass(["uppercase pl-4", {
        'w-full mb-2 uppercase rounded-md hover:bg-white hover:bg-opacity-5':
          _ctx.vertical,
      }]),
          onConnected: _ctx.toBridge
        }, null, 8, ["class", "onConnected"]))
      : (_openBlock(), _createBlock(_component_nomad_button, {
          key: 2,
          class: _normalizeClass(["uppercase pl-4", {
        'w-full mb-2 uppercase rounded-md hover:bg-white hover:bg-opacity-5':
          _ctx.vertical,
      }]),
          onClick: _ctx.toCoinList
        }, {
          default: _withCtx(() => [
            _createTextVNode(" CoinList Verify+ ")
          ]),
          _: 1
        }, 8, ["class", "onClick"])),
    _createVNode(_component_nomad_button, {
      class: _normalizeClass(["uppercase px-4", {
        'w-full mb-2 uppercase rounded-md hover:bg-white hover:bg-opacity-5':
          _ctx.vertical,
      }]),
      onClick: _ctx.toHistory
    }, {
      default: _withCtx(() => [
        _createTextVNode(" History ")
      ]),
      _: 1
    }, 8, ["class", "onClick"]),
    _createVNode(_component_nomad_button, {
      class: _normalizeClass(["uppercase px-4", {
        'w-full m-0 uppercase rounded-md hover:bg-white hover:bg-opacity-5':
          _ctx.vertical,
        'mr-4': !_ctx.vertical,
      }]),
      onClick: _ctx.toFAQ
    }, {
      default: _withCtx(() => [
        _createTextVNode(" FAQ ")
      ]),
      _: 1
    }, 8, ["class", "onClick"])
  ], 2))
}